$(function() {
  
    

    if($('body').hasClass('home')){

        home_hero_resize();

        do_home_ecosystem_block();

    }

    if($('.js-progress-bar-block').length > 0){

        do_progress_bar_block();

    }


    $('.page .wp-blocks > .wp-block-columns').each(function(){

        _col = $(this).find('> .wp-block-column');
        _col.each(function(i){

            _animated_item = $(this).find('*');

            _animated_item.attr('data-aos', 'fade-up');
            _animated_item.attr('data-aos-duration', '1500');
            _animated_item.attr('data-aos-delay', 300*i);

        });

    });
});



$(window).on('resize', function(){

    if($('body').hasClass('home')){

        home_hero_resize();

    }
	

});

function home_hero_resize(){

    if($(document).width() >= 1024){
        var _bottom = $('.js-home-hero-bottom').outerHeight() + 10;
        $('.hero-block').find('ul.slick-dots').css('bottom', _bottom + 'px');
    }
}


_accordion_breakpoint = 1024;

function do_home_ecosystem_block(){

    $('.js-home-ecosistema-block .ecosystem-item').on('click', function(){

		var _li = $(this); //.closest('li');
		
		var _is_expanded = _li.hasClass('expanded');

		if(!_is_expanded){

			collapse_accordion( $(this).closest('.lg-accordion'), false );
			expand_accordion_item(_li);
			return false;
		}

	});

    if($('.accordion-item.expanded').length > 0) {
	
		expand_accordion_item( $('.accordion-item.expanded'), false );

	}
    
    /* $('.js-solutions-next').on('click', function(){

        var _acc = $(this).closest('.home-solutions-block').find('.lg-accordion');

        var _index = _acc.find('.accordion-item.expanded').index();

        var _length = _acc.find('.accordion-item').length;

        var _new_index = _index >= (_length - 1) ? 0 : _index + 1;

        collapse_accordion(_acc, false);

        expand_accordion_item(_acc.find('.accordion-item').eq(_new_index));

    });

    $('.js-solutions-prev').on('click', function(){

        var _acc = $(this).closest('.home-solutions-block').find('.lg-accordion');

        var _index = _acc.find('.accordion-item.expanded').index();

        var _length = _acc.find('.accordion-item').length;

        var _new_index = _index <= 0 ? _length - 1 : _index - 1;

        collapse_accordion(_acc, false);

        expand_accordion_item(_acc.find('.accordion-item').eq(_new_index));

    }); */

}


function collapse_accordion(_accordion, _is_vertical = true){

	var _item = _accordion.find('li.accordion-item');
	
		_item.removeClass('expanded');
        
        if(_is_vertical) _item.find('.accordion-content').css('max-height', 0);
}


function expand_accordion_item(_item, _is_vertical = true){
	
	_item.addClass('expanded');
    
    _h = _item.find('.inner').innerHeight();

    if(_is_vertical) _item.find('.accordion-content').css('max-height', _h);

}

$(window).on('scroll', function(){
	blocks_scroll();
});


function blocks_scroll(){

    if($('.js-progress-bar-block').length > 0){

        do_progress_bar_block();

    }
}

function do_progress_bar_block(){

    $('.js-progress-bar-block').each(function(){

        var _block = $(this);
        var _t = _block.offset().top;
        var _T = $(window).scrollTop();
        var _H = $(window).height();

        if( (_T + _H) > _t ){
            if(!$(this).hasClass('active')) $(this).addClass('active');
        }

    });

}